module.exports = __webpack_public_path__ + "assets/b36b3e6989dc594ddb1dc3619193450f.png";